import React, { createContext, useContext } from "react";
import { useCart, type CartItem } from "@/hooks/use-cart";

interface CartContextValue {
  items: CartItem[];
  itemCount: number;
  cartId: string | null;
  loading: boolean;
  sessionToken: string;
  addItem: (params: {
    experience_id: string;
    slot_id: string;
    adult_count?: number;
    child_count?: number;
    toddler_count?: number;
  }) => Promise<any>;
  updateItem: (cartItemId: string, counts: { adult_count?: number; child_count?: number; toddler_count?: number }) => Promise<void>;
  removeItem: (cartItemId: string) => Promise<void>;
  clearCart: () => Promise<void>;
  refresh: () => void;
}

const CartContext = createContext<CartContextValue | null>(null);

export function CartProvider({ children }: { children: React.ReactNode }) {
  const cart = useCart();
  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
}

export function useCartContext() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCartContext must be used within CartProvider");
  return ctx;
}
